import React from 'react';
import { DARK_GREY } from '../../config/colors';
import MenuItem from 'material-ui/MenuItem';
import Popover, { PopoverAnimationVertical } from 'material-ui/Popover';
import { Link } from 'react-router-dom'
import CustomerTypes from '../../const/customer_type.js'
import MedicalIcon from '../../icons/MedicalIcon';
import RecreationalIcon from '../../icons/RecreationalIcon';
import ArrowDown from '../../icons/ArrowDown';
import Menu from 'material-ui/Menu';
import { connect } from "react-redux";

import { getSelectedCustomerType } from "../../selectors/customer_type_selector";
import { updateCustomerType } from '../../actions/customer_type_actions';
import { getCartIconColor } from '../../selectors/configSelectors';
import { RECREATIONAL_TEXT } from '../../const/cart_const';

const customerTypeMenuItemStyles = {height: "20px", width: '20px', 'margin': '5px 5px 15px', 'overflow': 'visible'};
const activeCustomerTypeOptionStyles = { height: "20px", width: '40px', 'marginBottom': '15px', 'overflow': 'visible' };

class CustomerTypeDropdown extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isCustomerTypeMenuOpen: false
    }
  }

  handleCustomerTypeMenuClick = (event) => {
    event.preventDefault();

    this.setState({
      isCustomerTypeMenuOpen: true,
      anchorEl: event.currentTarget
    });
  }

  closeCustomerTypeMenu = () => {
    this.setState({
      isCustomerTypeMenuOpen: false
    });
  }

  getActiveCustomerTypeOption = () => {
    const { selectedCustomerType: customerType } = this.props;

    const CustomerTypeIcon = customerType === CustomerTypes.ADULT ? RecreationalIcon : MedicalIcon;
    const customerTypeText = customerType === CustomerTypes.ADULT ? RECREATIONAL_TEXT : CustomerTypes.MEDICAL;

    return (
      <div onClick={this.handleCustomerTypeMenuClick} className="d-flex align-items-center">
        <CustomerTypeIcon style={activeCustomerTypeOptionStyles} color={`#${this.props.cartIconColor}`} />

        <span className="welcome-wrapper">&nbsp;&nbsp;{customerTypeText}</span>
        <ArrowDown color={`#${this.props.cartIconColor}`} />
      </div>
    );
  }

  changeCustomerType = (customerType) => {
    this.props.updateCustomerType(customerType);
    this.closeCustomerTypeMenu();
  }
  
  render() {
    return (
      <div>
        {this.getActiveCustomerTypeOption()}

        <Popover
          open={this.state.isCustomerTypeMenuOpen}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={this.closeCustomerTypeMenu}
          style={{ right: 0, left: 'unset', width: 'fit-content' }}>
          <Menu>
            <MenuItem
              onClick={this.changeCustomerType.bind(this, CustomerTypes.ADULT)}
              primaryText={RECREATIONAL_TEXT}
              innerDivStyle={{ padding: '0 12px 0 50px' }}
              leftIcon={<RecreationalIcon style={customerTypeMenuItemStyles} color={DARK_GREY} />} />

            <MenuItem
              onClick={this.changeCustomerType.bind(this, CustomerTypes.MEDICAL)}
              primaryText={CustomerTypes.MEDICAL}
              innerDivStyle={{ padding: '0 12px 0 50px' }}
              leftIcon={<MedicalIcon style={customerTypeMenuItemStyles} color={DARK_GREY} />} />
          </Menu>
        </Popover>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    selectedCustomerType: getSelectedCustomerType(state),
    cartIconColor: getCartIconColor(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateCustomerType: customerType => dispatch(updateCustomerType(customerType))
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(CustomerTypeDropdown);



// WEBPACK FOOTER //
// ./src/components/CustomerTypeDropdown/CustomerTypeDropdown.jsx